import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { Text } from '../../../../components';
import { device } from '../../../../constants';

interface DivProps extends React.HTMLProps<HTMLDivElement> {
  title?: string;
  text?: string;
  description?: string;
  counter: ReactNode;
  screenshot: ReactNode;
}

export const Result: React.FC<DivProps> = ({
  title,
  description,
  counter,
  screenshot,
  ...props
}) => {
  return (
    <ElementStyle {...props}>
      <ResultTextContainer>
        <ResultCounter>{counter}</ResultCounter>
        <ResultText>
          <Text text={title} size={24} weight={600} lineHeight={32} />
          <Text text={description} />
        </ResultText>
      </ResultTextContainer>

      <ResultScreenshotContainer>{screenshot}</ResultScreenshotContainer>
    </ElementStyle>
  );
};

const ElementStyle = styled.div`
  display: flex;
  align-items: center;
  gap: 160px;
  width: 100%;
  @media screen and ${device.lg} {
    gap: 10px;
  }
  @media screen and ${device.sm} {
    flex-direction: column-reverse;
  }
`;

const ResultTextContainer = styled.div`
  width: 523px;
  @media screen and ${device.lg} {
    width: auto;
    flex-shrink: 1;
  }
  @media screen and ${device.sm} {
    width: 100%;
  }
`;

const ResultScreenshotContainer = styled.div`
  min-width: 291px;
  max-width: 50%;
  height: 581px;
  border-radius: 10px;
  @media screen and ${device.lg} {
    width: 30%;
    flex-shrink: 0;
  }
  @media screen and ${device.md} {
    min-width: 50%;
  }
  @media screen and ${device.sm} {
    width: 100%;
    height: 200px;
  }
`;
const ResultText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  @media screen and ${device.sm} {
    gap: 5px;
    h4 {
      font-size: 16px;
      line-height: 20px;
    }
  }
`;

const ResultCounter = styled.div`
  width: 76px;
  min-height: 70px;
  margin-bottom: 60px;
  @media screen and ${device.md} {
    margin-bottom: 0;
  }
  @media screen and ${device.sm} {
    min-height: 30px;
    width: 40px;
  }
`;
